import { GridTemplateToken } from './types';

/**
 * A plain template token simply denotes a value.
 */
export class Plain implements GridTemplateToken {
  private value: string;

  public constructor(value: string | number) {
    this.value = typeof value === 'number' ? `${value}px` : value;
  }

  public expandMsTokenWithGap(gap: string): string[] {
    return [this.value, gap];
  }

  public expandMsToken(): string {
    return this.value;
  }

  public expandToken(): string {
    return this.value;
  }
}

/**
 * Factory function for creating plain lengths which are not arguments of a CSS Grid function and
 * are used in the CSS Grid. String values are passed through; number values are converted to pixel
 * string values.
 *
 * @param value The length in string or number form
 */
export const plain = (value: string | number): Plain => new Plain(value);
